// Which packs a product offers. A product marked Loose is sold and requested by
// weight only, so it offers none; a retired (off-sale) pack is kept for its
// history but is never offered either. Use this wherever someone PICKS a pack —
// not where an existing record needs its pack's label.
export const isLoose = (p) => p?.sellMode === 'loose';
export const packsOf = (p) => (isLoose(p) ? [] : (p?.variants || []).filter((v) => v.isSellable !== false));
